module.exports = __webpack_public_path__ + "assets/img/contractcomparsion-func1.19178517.png";